import {
    REQUEST_FORM_SUBMIT_PAYMENT,
    SUCCESS_FORM_SUBMIT_PAYMENT,
    FAILURE_FORM_SUBMIT_PAYMENT
} from './constants';
import { CALL_API } from '../../../../middlewares/api';
import _ from 'lodash';
import { fetchPaymentRequestOnGoingIfNeeded } from '../ongoing/actions';

export const ERROR_FORMDATA_EMPTY =
    '[sendPaymentRequest]formData param must not be empty or null or undefined !';

/**
 * Send payment request form to server
 * headers = {} to put empty headers in request
 * @param {FormData} formData
 */
export function sendPaymentRequest(formData, callback) {
    if (_.isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: '/paymentrequest',
            types: [
                REQUEST_FORM_SUBMIT_PAYMENT,
                SUCCESS_FORM_SUBMIT_PAYMENT,
                FAILURE_FORM_SUBMIT_PAYMENT
            ],
            body: formData,
            successCallback: (response, dispatch) => {
                dispatch(fetchPaymentRequestOnGoingIfNeeded());
                if (callback) {
                    callback();
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/request/actions.js